import { useState, useEffect } from 'react'
import styled from 'styled-components'

import { mediaMax } from 'styles/media'
import FilterButton from '../desktop/FilterButton'
import QuantitySelect from './QuantitySelect'

type RoomsAndBedsFilters = {
  bedrooms?: number
  beds?: number
}

type RoomsAndBedsProps = {
  values: RoomsAndBedsFilters
  onChange: (nextFilters: RoomsAndBedsFilters) => void
}

const RoomsAndBedsWrapper = styled.div`
  ${mediaMax.xl`
    margin-bottom: 14px;
  `}
`

export const RoomsAndBeds = ({ values, onChange }: RoomsAndBedsProps) => {
  return (
    <RoomsAndBedsWrapper>
      <QuantitySelect
        label="Bedrooms"
        maxValue={20}
        value={values.bedrooms}
        onChange={(count) => onChange({ bedrooms: count })}
      />
      <QuantitySelect
        label="Beds"
        maxValue={20}
        value={values.beds}
        onChange={(count) => onChange({ beds: count })}
      />
    </RoomsAndBedsWrapper>
  )
}

type RoomsAndBedsFilterProps = RoomsAndBedsProps

const RoomsAndBedsFilter = ({ values, onChange }: RoomsAndBedsFilterProps) => {
  const [state, setState] = useState(values)
  const activeFilters = Object.keys(values).length

  // Override state if values passed in via props changes:
  useEffect(() => setState(values), [values])

  const handleClear = () => {
    // Set all values to null so that the `onChange` handler knows to clear out
    // those values from the query string:
    const resetState: RoomsAndBedsFilters = {
      bedrooms: null,
      beds: null,
    }

    setState(resetState)
    onChange(resetState)
  }

  const handleChange = (changes: RoomsAndBedsFilters) => {
    setState({ ...state, ...changes })
  }

  return (
    <FilterButton
      label="Rooms and beds"
      badge={activeFilters > 0 ? activeFilters.toString() : null}
      isActive={activeFilters > 0}
      onApply={() => onChange(state)}
      onClear={handleClear}
      onReset={() => setState(values)}
    >
      <RoomsAndBeds values={state} onChange={handleChange} />
    </FilterButton>
  )
}

export default RoomsAndBedsFilter
